import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { requestYieldCallback } from '@theme/utilities';

export default class ProductFlavorPicker extends Component {
  #abortController;

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const target = event.target;
    const link = target?.closest('a[data-flavor-url]');
    if (!(link instanceof HTMLAnchorElement)) return;

    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) {
      return;
    }

    const newUrl = link.dataset.flavorUrl;
    if (!newUrl) return;

    event.preventDefault();

    if (link.dataset.flavorProductId === this.dataset.currentProductId) return;

    this.#switchFlavor(newUrl);
  };

  #switchFlavor(newUrl) {
    this.#abortController?.abort();
    this.#abortController = new AbortController();

    const optionValues = this.#currentSelectedOptionValues();
    const fetchUrl = new URL(newUrl, window.location.origin);
    if (optionValues.length) {
      fetchUrl.searchParams.set('option_values', optionValues.join(','));
    }

    this.dataset.loading = 'true';

    fetch(fetchUrl.toString(), { signal: this.#abortController.signal })
      .then((response) => {
        if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);
        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const newMain = html.querySelector('main');
        const currentMain = document.querySelector('main');

        if (!newMain || !currentMain) {
          throw new Error('main element not found in fetched document');
        }

        morph(currentMain, newMain);

        const newTitle = html.querySelector('title')?.textContent;
        if (newTitle) document.title = newTitle;

        requestYieldCallback(() => {
          history.pushState({}, '', newUrl);
        });
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        console.error('[product-flavor-picker]', error);
        window.location.href = newUrl;
      })
      .finally(() => {
        delete this.dataset.loading;
      });
  }

  #currentSelectedOptionValues() {
    const variantPicker = document.querySelector('variant-picker[data-template-product-match="true"]');
    if (!variantPicker) return [];

    const selected = variantPicker.querySelectorAll('select option[selected], fieldset input:checked');
    return Array.from(selected)
      .map((el) => el.dataset.optionValueId)
      .filter((id) => Boolean(id));
  }
}

if (!customElements.get('product-flavor-picker')) {
  customElements.define('product-flavor-picker', ProductFlavorPicker);
}
